import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import * as userActions from 'store/user/actions';

import { useForm } from 'react-hook-form';
import { Redirect } from 'react-router';
import { Button } from 'components/styled/shared/Button';
import { TextInputField } from 'components/presentational/shared/TextInputField';
import {
  LoginFormWrapper,
  LoginFormErrorField,
  ButtonWrapper,
  VerifyForm,
} from 'components/styled/login/LoginFormWrapper';

type FormData = {
  code: string;
};

export const Verify: React.FC = () => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm<FormData>();
  const userState = useSelector((state: ApplicationState) => state.user);
  const { verification } = userState;

  if (!verification || !verification.challengeName || !verification.session) {
    return <Redirect to="/login" />;
  }

  const onSubmit = handleSubmit(({ code }) => {
    if (verification.user && verification.session) {
      dispatch(
        userActions.accountVerification(
          code,
          verification.session,
          verification.user
        )
      );
    }
  });

  const onCancelVerification = () => {
    dispatch(userActions.cancelVerification());
  };

  return (
    <LoginFormWrapper>
      <h2>Verification</h2>
      <VerifyForm onSubmit={onSubmit}>
        {(userState.error || userState.error === 0) && (
          <LoginFormErrorField>
            <span>
              The code is invalid or the token is expired, please try to log in
              again!
            </span>
          </LoginFormErrorField>
        )}
        <TextInputField
          name="code"
          required="Please enter your code"
          register={register}
          errors={errors}
          placeholder="Code"
          autoFocus={true}
        />
        <ButtonWrapper>
          <Button>Verify</Button>
          <Button onClick={() => onCancelVerification()}>
            Cancel verification
          </Button>
        </ButtonWrapper>
      </VerifyForm>
    </LoginFormWrapper>
  );
};
